import React, { useContext } from "react";
import themeContext from "../context/themeContext";
import parse from "html-react-parser";
import { Row, Col } from "antd";
import mainContext from "../context/mainContext";
export default function MyMarquee() {
  const ctxmain = useContext(mainContext);
  return (
    <Row style={{ background: `rgba(0,0,0, 0.9)` }}>
      <Col span={24} style={{ color: "yellow", fontWeight: "bold" }}>
        <div align="center" style={{ padding: "5px" }}>
          <marquee>
            {typeof ctxmain.txtmarquee == "string" && parse(ctxmain.txtmarquee)}
          </marquee>
        </div>
      </Col>
    </Row>
  );
}
